import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Card,
  Checkbox,
  CircularProgress,
  Container,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Modal,
  Select,
  TextareaAutosize,
  TextField,
  Typography,
} from "@mui/material";
import Autocomplete from '@mui/material/Autocomplete';
import { useLocation, useNavigate } from "react-router-dom";
import Layout from "components/structure/Layout";
import { AuthData } from "auth/AuthWarpper";
import './Questionnare.css'
import QuestionnareService from "services/QuestionnareService";
import CommonService from "services/CommonService";
import SearchIcon from '@mui/icons-material/Search';
import CheckboxTick from "assets/CheckboxTick.svg";
import CheckboxUntick from "assets/CheckboxUntick.svg";
import { SnackbarContext } from "context/snackBarContext";
import { debounceCustom, validateForm } from "utils/CommonFunction";
import { equalsIgnoreCase } from "utils/utils";
import DropdownModal from "./DropdownModal";
import SeasonRegistrationService from "services/SeasonRegistrationService";
let setOriginalQuestionSequence = 0;
let setStaticFormValue = {}
let setStaticSelectedCropYear = ""

const QuestionnareAdd = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const textFieldRef = useRef(null);
  const { user } = AuthData();
  const [loading, setLoading] = useState(false);
  const [countries, setCountries] = React.useState([]);
  const [modules, setModules] = useState([]);
  const [subModules, setSubModules] = useState([]);
  const [cropYears, setCropYears] = useState([]);
  const [cropStages, setCropStages] = useState([]);
  const [questionCode, setQuestionCode] = useState("");
  const [questionSequence, setQuestionSequence] = useState("");
  const [pickListData, setPickListData] = useState();
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState(['Option 1', 'Option 2', 'Option 3']);
  const [selected, setSelected] = useState([]);
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [submoduleCountries, setSubmoduleCountries] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [mode, setMode] = useState("Add");
  const [openModal, setOpenModal] = useState(false);
  const [isMultiSelect, setIsMultiSelect] = useState(false);
  const [modalRows, setModalRows] = useState([]);
  const [promptMandatory, setPromptMandatory] = useState(false);
  const [parentMandatory, setParentMandatory] = useState(false);
  const [selectedCropYear, setSelectedCropYear] = useState('');
  const [questionSequenceDisabled, setQuestionSequenceDisabled] = useState(false);
  const [selectedParentOption, setSelectedParentOption] = useState(null);
  const [textFieldWidth, setTextFieldWidth] = useState(null);
  const [selectedResponseDescription, setSelectedResponseDescription] = useState('');
  const [parentResponseOptions, setParentResponseOptions] = useState([]);
  const [mandatoryCountries, setMandatoryCountries] = useState([]);
  const [auditCountries, setAuditCountries] = useState([]);
  const [activeCountries, setActiveCountries] = useState([]);
  const [promptActionCountries, setPromptActionCountries] = useState([]);
  const {
    setOpenAlert,
    setSeverity,
    setMessage,
  } = React.useContext(SnackbarContext);

  const User = JSON.parse(sessionStorage.getItem('BAT_USER'))
 let isGlobalUser=User?.userAttribute == "Global"

   const readOnly = location.state?.readOnly ?? true;

  const [formValues, setFormValues] = React.useState(
    {
      cropYear: {
        value: "",
        error: false,
        errorMessage: "You must select crop year",
      },
      cropStage: {
        value: "",
        error: false,
        errorMessage: "You must select crop stage",
      },
      moduleName: {
        value: "",
        error: false,
        errorMessage: "You must select module name",
      },
      subModuleName: {
        value: "",
        error: false,
        errorMessage: "You must select sub module name",
      },
      country: {
        value: "",
        error: false,
        errorMessage: "You must select country",
      },
      questionCode: {
        value: "",
        error: false,
        errorMessage: "You must provide question code",
      },
      questionType: {
        value: "",
        error: false,
        errorMessage: "You must provide question type",
      },
      questionSequence: {
        value: "",
        error: false,
        errorMessage: "You must provide question sequence",
      },
      responseType: {
        value: "",
        error: false,
        errorMessage: "You must provide response type",
      },
      mandatory: {
        value: false,
        error: false,
        errorMessage: "",
      },
      audit: {
        value: false,
        error: false,
        errorMessage: "",
      },
      active: {
        value: false,
        error: false,
        errorMessage: "",
      },
      multiInstance: {
        value: "false",
        error: false,
        errorMessage: "",
      },

      promptAction: {
        value: "",
        error: false,
        errorMessage: "You must select prompt action",
      },
      promptActionReponseCondition: {
        value: "",
        error: false,
        errorMessage: "You must select prompt action response condition",
      },
      promptActionReponseValue: {
        value: "",
        error: false,
        errorMessage: "You must select prompt action response value",
      },
      parentQuestion: {
        value: "",
        error: false,
        errorMessage: "You must provide parent question",
      },
      parentCondition: {
        value: "",
        error: false,
        errorMessage: "You must select parent condition",
      },
      parentReponseValue: {
        value: "",
        error: false,
        errorMessage: "You must provide parent response value",
      },
      questionText: {
        value: "",
        error: false,
        errorMessage: "You must provide question text",
      },
    }
  );
  //Initial fetch
  useEffect(() => {
    FetchCropYears()
    fetchPickList();
    let state = location?.state;
    if (state?.mode == "Edit" || state?.mode == "View") {
      setMode(state?.mode)
    }
  }, [])
  //fetch modules when crop year || crop stage changes
  useEffect(() => {
    if (selectedCropYear && formValues.cropStage.value) {
      FetchModSub(selectedCropYear, formValues.cropStage.value)
      setSelected([])
    }
  }, [formValues?.cropStage?.value, formValues?.cropYear?.value])
  //SET submodules when module gets changed
  useEffect(() => {
    if (selectedCropYear && formValues.moduleName.value) {
      let moduleId = formValues.moduleName.value;
      const selectedModule = modules.find(item => item.moduleId === moduleId);
      setSubModules(selectedModule?.subModules || []);

      // When submodule is selected, update its countries
      if (formValues.subModuleName.value) {
        const selectedSubmodule = selectedModule?.subModules?.find(
          sub => sub.subModuleId === formValues.subModuleName.value
        );

        if (selectedSubmodule?.subModuleCountryLinks) {
          const formattedCountries = selectedSubmodule.subModuleCountryLinks.map(country => ({
            countryId: country.countryId,
            countryCode: country.countryCode,
            countryName: country.countryName
          }));
          
          setSubmoduleCountries(formattedCountries);
          setSelectedCountries(formattedCountries);
          setSelected(formattedCountries);
          setMandatoryCountries(formattedCountries);
          setAuditCountries(formattedCountries);
          setActiveCountries(formattedCountries);
          setPromptActionCountries(formattedCountries);

          // Update form values with the countries
          setFormValues(prev => ({
            ...prev,
            country: {
              value: formattedCountries,
              error: false,
              errorMessage: "You must select country"
            }
          }));
        }
      }
    }
  }, [formValues?.moduleName?.value, formValues?.subModuleName?.value])
  //fetch question seq & code when module or submodues changed
  useEffect(() => {
    if (formValues.moduleName.value !== "" && formValues.subModuleName.value !== "") {
      let moduleId = formValues.moduleName.value;
      let submoduleId = formValues.subModuleName.value;
      let moduleIndex = modules.findIndex(item => item.moduleId === moduleId);
      let submoduleIndex = modules[moduleIndex]?.subModules?.findIndex(item => item.subModuleId === submoduleId);
      let moduleName = modules[moduleIndex]?.moduleName;
      let submoduleName = modules[moduleIndex]?.subModules[submoduleIndex]?.subModuleName;
      let cropStageIndex = cropStages.findIndex(item => item.cropStageUid == formValues.cropStage.value);
      let cropStageName = cropStages[cropStageIndex]?.cropStageName
      if (submoduleName == undefined) return
      FetchCode(formValues.cropStage.value, formValues.moduleName.value, formValues.subModuleName.value, moduleName, submoduleName, cropStageName)
    }
  }, [formValues?.cropStageName?.value, formValues?.moduleName?.value, formValues?.subModuleName?.value])
  //search question sequence on submodule change
  useEffect(() => {
    let qtype = getPickListDescription("EQSTYP", formValues?.questionType?.value)
    if (formValues.subModuleName.value) {
      if (formValues?.parentQuestion?.value != undefined && formValues?.parentQuestion?.value != "" && qtype == "Dependant") {
        FetchQuestionSequence(formValues.moduleName.value)

      } else {
        FetchQuestionSequence(formValues.moduleName.value);
      }
    }
  }, [formValues?.subModuleName?.value, formValues?.questionType?.value, formValues?.parentQuestion?.value])
  //effect to search parent question on input change
  useEffect(() => {
    searchParent(inputValue)
  }, [inputValue, formValues?.cropYear?.value, formValues?.cropStage?.value, formValues?.moduleName?.value, formValues?.subModuleName?.value]);

  useEffect(() => {
    updateTextFieldWidth();
    window.addEventListener('resize', updateTextFieldWidth);
    return () => {
      window.removeEventListener('resize', updateTextFieldWidth);
    };
  }, []);
  useEffect(() => {
    if (selected && selected.length > 0) {
      setSelectedCountries(selected);
    }
  }, [selected]);

  useEffect(() => {
    // Filter out countries that are no longer in main selection
    setMandatoryCountries(prev => 
      prev.filter(country => 
        selectedCountries.some(mainCountry => mainCountry.countryId === country.countryId)
      )
    );
    setAuditCountries(prev => 
      prev.filter(country => 
        selectedCountries.some(mainCountry => mainCountry.countryId === country.countryId)
      )
    );
    setActiveCountries(prev => 
      prev.filter(country => 
        selectedCountries.some(mainCountry => mainCountry.countryId === country.countryId)
      )
    );
    setPromptActionCountries(prev => 
      prev.filter(country => 
        selectedCountries.some(mainCountry => mainCountry.countryId === country.countryId)
      )
    );
  }, [selectedCountries]);

  
  const updateTextFieldWidth = () => {
    if (textFieldRef.current) {
      setTextFieldWidth(textFieldRef?.current?.node?.offsetWidth);
    }
  };
  const handleChange = (e) => {
    let { name, value, checked } = e.target;
    const regex = /^(?!\s)(?!.*\s{2,}).*$/;
    const isValid = regex.test(value);
    if (name == "active" || name == "mandatory" || name == "audit" || name == "multiInstance") {
      value = checked;
    }
    const regex2 = /^(?!\s)(?!.*\s{2,}).*$/;
    if (name == 'questionSequence') {
      const numberRegex = /^[1-900000]*$/; 
      const isValidNumber = numberRegex.test(value);
      if (!isValidNumber){
        setMessage("Only integer values are allowed");
        setSeverity("error");
        setOpenAlert(true);
        return
      }
      if (value > setOriginalQuestionSequence) {
        setMessage(`Value cannot be greater then ${setOriginalQuestionSequence}`);
        setSeverity("error");
        setOpenAlert(true);
        return
      }
      if (value < setOriginalQuestionSequence) {
        if (value != "" && value != 0)  {
          setMessage(`Question Sequence already in use. Do you still want to insert at this sequence?`);
          setSeverity("error");
          setOpenAlert(true);
        }
      }
   setQuestionSequence(value)
    }
    if (regex2.test(value) || value === "") {
    } else {
      if (name == "email") {
      } else {
        return;
      }
    }
    const hasTrailingSpaces = !isValid;
    let newFormValues = {
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
        error: hasTrailingSpaces ? true : false,
        errorMessage: hasTrailingSpaces
          ? "Trailing spaces are not allowed"
          : formValues[name].errorMessage,
      },
    }
    setFormValues(newFormValues);
    setStaticFormValue = { ...formValues }
    if (name == 'cropYear') {
      setSelectedCropYear(value)
      setStaticSelectedCropYear = value
    }
    if (name == 'responseType') {
      // handleResponseType(value) // for loading modal logic
      handlePromtMandatory(value, newFormValues) // for marking  prompt mandatory as i.e dependent on this field
    }
    if (name == 'questionType') {
      handleParentMandatory(value, newFormValues)
    }
  };
  // const handleResponseType = (value) => {
  //   let description = getPickListDescription("ERSPTYP", value)
  //   if (description == "Dropdown" || description == "Multi Select Dropdown") {
  //     setOpenModal(true)
  //     if (description == "Multi Select Dropdown") {
  //       setIsMultiSelect(true)
  //     } else {
  //       setIsMultiSelect(false)
  //     }
  //   } else {
  //     setIsMultiSelect(false)
  //   }
  // }
  const handlePromtMandatory = (value, newFormValues) => {
    let type = getPickListDescription("ERSPTYP", value)
    if (type == "Dropdown" || type == "Multi Select Dropdown" || type == "Numeric" || type == "Integer" || type == "Radio Button (Yes / No)") {
      setPromptMandatory(true)
      // let id = getPickListIdFromDescription("EQPACT", "No")
      // setFormValues({
      //   ...newFormValues,
      //   ['promptAction']: {
      //     value: id,
      //     error: false,
      //     errorMessage: "You must select prompt action",
      //   }
      // })
    } else {
      setPromptMandatory(false)
      let id = getPickListIdFromDescription(pickListData, "EQPACT", "No")
      setFormValues({
        ...newFormValues,
        ['promptAction']: {
          value: id,
          error: false,
          errorMessage: "You must select prompt action",
        }
      })


      // setFormValues({
      //   ...newFormValues,
      //   ['promptAction']: {
      //     value: "",
      //     error: false,
      //     errorMessage: "You must select prompt action",
      //   }
      // })
    }
  }
  const handleParentMandatory = (value, newFormValues) => {
    let type = getPickListDescription("EQSTYP", value)
    if (type == "Dependant") {
      if (formValues?.parentQuestion?.value == "" || formValues?.parentQuestion?.value == undefined) {
        setQuestionSequenceDisabled(true)
      }
      setParentMandatory(true)
    } else {
      setSelectedParentOption(null)
      setParentMandatory(false)
      setQuestionSequenceDisabled(false)
      setFormValues({
        ...newFormValues,
        ['parentCondition']: {
          value: "",
          error: false,
          errorMessage: "You must provide parent condition",
        },
        ['parentReponseValue']: {
          value: "",
          error: false,
          errorMessage: "You must provide parent response value",
        },

      })

    }
  }

  const FetchQuestionSequence = (moduelId) => {
    setLoading(true)
    QuestionnareService.FetchQuestionSequence({ moduelId }).then((res) => {
      setLoading(false)
      let data = res?.data?.response;
      setQuestionSequence(data);
      setOriginalQuestionSequence = data;
      setFormValues({
        ...formValues,
        ['questionSequence']: {
          value: data,
          error: false,
          errorMessage: "You must provide question sequence",
        }
      })
      setLoading(false)
    }).catch((ex) => {
      console.log('error', ex)
      setLoading(false)
    })
  }
  const searchParent = useCallback(
    debounceCustom((userInput) => {
      const params = new URLSearchParams();
      params.append('cropYear', setStaticSelectedCropYear);
      params.append('cropStage', setStaticFormValue?.cropStage?.value);
      // params.append('moduelId', setStaticFormValue?.moduleName?.value);
      // params.append('subModuelId', setStaticFormValue?.subModuleName?.value);
      params.append('userInput', userInput);

      // if (setStaticFormValue?.cropYear?.value == undefined || setStaticFormValue?.cropYear?.value == "") return
      if (setStaticFormValue?.cropStage?.value == undefined || setStaticFormValue?.cropStage?.value == "") return
      if (setStaticFormValue?.moduleName?.value == undefined || setStaticFormValue?.moduleName?.value == "") return
      if (setStaticFormValue?.subModuleName?.value == undefined || setStaticFormValue?.subModuleName?.value == "") return
      setLoading(true)
      QuestionnareService.SearchParent({ params }).then((res) => {
        setLoading(false)
        let data = res?.data?.response?.questions;
        setOptions(data)
        // if (data?.length == 0) {
        //   setMessage(`Unable to find question`);
        //   setSeverity("error");
        //   setOpenAlert(true);
        // } else {
        //   setOptions(data)
        // }
        setLoading(false)
      }).catch((ex) => {
        // setMessage(`Unable to find question`);
        // setSeverity("error");
        // setOpenAlert(true);
        console.log('error', ex)
        setLoading(false)
      })
    }, 1000) // Adjust delay as needed
    // Empty dependency array means this function is created only once,
    , []
  );
  const FetchCode = (cropStageId, moudleId, subModuleId, moduelName, subModuelName, cropStageName) => {
    setLoading(true)
    QuestionnareService.FetchCode({cropStageId, moudleId, subModuleId, moduelName, subModuelName, cropStageName }).then((res) => {
      setLoading(false)
      let d = res?.data?.response;
      setFormValues({
        ...formValues,
        ['questionCode']: {
          value: d,
          error: false,
          errorMessage: "You must provide question code",
        }
      })
      setStaticFormValue = { ...formValues }
      setQuestionCode(d);
    }).catch((ex) => {
      console.log('error', ex)
      setLoading(false)
    })
  }
  const FetchModSub = (cropYearId, cropStageId) => {
    setLoading(true);
    QuestionnareService.FetchModSub({ cropYearId, cropStageId }).then((res) => {
      setLoading(false);
      let data = res?.data?.response;
      setCountries(data?.countryDtoList);
      setModules(data?.modules);

      // If submodule is already selected, set its countries
      if (formValues.subModuleName.value) {
        const selectedModule = data?.modules?.find(
          module => module.moduleId === formValues.moduleName.value
        );
        const selectedSubmodule = selectedModule?.subModules?.find(
          sub => sub.subModuleId === formValues.subModuleName.value
        );

        if (selectedSubmodule?.subModuleCountryLinks) {
          const formattedCountries = selectedSubmodule.subModuleCountryLinks.map(country => ({
            countryId: country.countryId,
            countryCode: country.countryCode,
            countryName: country.countryName
          }));
          setSubmoduleCountries(formattedCountries);
          setSelectedCountries(formattedCountries);
          setSelected(formattedCountries);
        }
      }
    }).catch((ex) => {
      console.log('error', ex);
      setLoading(false);
    });
  }
  const FetchCropYears = () => {
    setLoading(true)
    SeasonRegistrationService.getCropYears().then((res) => {
      setLoading(false)
      let data = res?.data?.response;
      const formattedYear = data?.map(({ cropYear, ...rest }) => ({
        cyCropYear: cropYear,
        ...rest
      }));
      setCropYears(formattedYear)
      let cyId = ""
      if (data?.length > 0) {
        const index = data?.findIndex(item => item?.isCurrentCropYear == true);
        cyId = data[index]?.cropYearUid
        setSelectedCropYear(cyId);
      }
      FetchYearAndStages(cyId)
    }).catch((ex) => {
      console.log('error', ex)
      setLoading(false)
    })
  }
  const FetchYearAndStages = (cyId) => {
    setLoading(true)
    QuestionnareService.FetchDropdown().then((res) => {
      setLoading(false)
      let data = res?.data?.response;
      // setCropYears(data?.cropYearResponse)
      // if (data?.cropYearResponse.length > 0) {
      //   let cy = new Date().getFullYear()
      //   const index = data?.cropYearResponse?.findIndex(item => item.cyCropYear == cy);
      //   setSelectedCropYear(data?.cropYearResponse[index]?.cropYearUid)
      //   setStaticSelectedCropYear = cyId
      //   setFormValues({
      //     ...formValues,
      //     ['cropYear']: { value:cyId, errorMessage: "You must select crop year", error: false },
      //   });
      // }
      setStaticSelectedCropYear = cyId
      setFormValues({
        ...formValues,
        ['cropYear']: { value:cyId, errorMessage: "You must select crop year", error: false },
      });
      setCropStages(data?.cropStageResponse)
    }).catch((ex) => {
      console.log('error', ex)
      setLoading(false)
    })
  }
  const fetchPickList = () => {
    setLoading(true)
    CommonService.fetchPickList({ pickListCodes: ['EQSTYP', 'EQPACT', 'ERSPCON', 'ERSPTYP'] }).then((res) => {
      setLoading(false)
      let data = res?.data?.response;
      setPickListData(data);

      let id = getPickListIdFromDescription(data, "EQPACT", "No")
      setFormValues({
        ...formValues,
        ['promptAction']: {
          value: id,
          error: false,
          errorMessage: "You must select prompt action",
        }
      })

    }).catch((ex) => {
      console.log('error', ex)
      setLoading(false)
    })
  }
  const handleSubmit = async (e, isPublished) => {
    e.preventDefault();

    const { errors, message } = validateCountryDropdowns();
    if (errors) {
      setMessage(message);
      setSeverity("error");
      setOpenAlert(true);
      return;
    }

    const formFields = Object.keys(formValues);
    let newFormValues = { ...formValues }
    if (selectedCountries.length === 0) {
      newFormValues = {
        ...newFormValues,
        country: {
          value: '',
          error: true,
          errorMessage: "You must select country"
        }
      };
    } else {
      newFormValues = {
        ...newFormValues,
        country: {
          value: selectedCountries,
          error: false,
          errorMessage: ""
        }
      };
    }
    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formValues[currentField].value;
 // Skip validation for checkbox fields and their country selections
 if (currentField === 'active' || currentField === 'audit' || 
  currentField === 'mandatory' || currentField === 'country') {
continue;
}

      if (currentValue == '' || currentValue === undefined) {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: currentField == 'questionCode' ? false : true
          }
        }
      }
      if ((currentField == 'questionSequence')) {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: currentValue ? questionSequence ? false : true : false,
          }
        }
      }
      if (currentField == 'cropYear' && currentValue == "Crop Year") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          }
        }
      }
      if (currentField == 'cropYear' && selectedCropYear != "") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: false,
          }
        }
      }
      if (currentField == 'cropStage' && currentValue == "") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          }
        }
      }
      if (currentField == 'moduleName' && currentValue == "") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          }
        }
      }
      if (currentField == 'subModuleName' && currentValue == "") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          }
        }
      }
      if (currentField == 'country' && currentValue == "Country") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          }
        }
      }
      if (currentField == 'questionType' && currentValue == "Question Type") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          }
        }
      }
      if (currentField == 'responseType' && currentValue == "Answer Type") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          }
        }
      }
      if ((currentField == 'promptAction')) {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: false,
          }
        }
      }
      if ((currentField == 'promptAction' && currentValue == "Prompt Action")) {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          }
        }
      }
      if ((currentField == 'promptActionReponseCondition')) {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            value: currentValue == "Select Condition" ? "" : currentValue,
            error: promptMandatory ? currentValue ? currentValue == "Select Condition" ? true : false : true : false,
          }
        }
      }
      if ((currentField == 'promptActionReponseValue')) {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: promptMandatory ? currentValue ? false : true : false,
          }
        }
      }
      if ((currentField == 'parentQuestion')) {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            value: parentMandatory == false ? "" : currentValue,
            error: parentMandatory ? currentValue == "" || currentValue == undefined ? true : false : false,
          }
        }
      }
      if ((currentField == 'parentCondition')) {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            value: parentMandatory == false ? "" : currentValue,
            error: parentMandatory ? currentValue == "" || currentValue == "Select Parent Condition" ? true : false : false,
          }
        }
      }
      if ((currentField == 'parentReponseValue')) {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            value: parentMandatory == false ? "" : currentValue,
            error: parentMandatory ? currentValue != "" ? false : true : false,
          }
        }
      }
        
    }
    let type = getPickListDescription("EQSTYP", newFormValues?.questionType?.value)
        if(type == "Dependant"){
         let selectedParent = options?.find((ele) => ele?.questionId == newFormValues?.parentQuestion?.value)
         if(selectedParent && selectedParent?.moduleId == newFormValues?.moduleName?.value){
          if(newFormValues?.questionSequence?.value <= selectedParent?.questionSequence){
            setMessage(`Question Sequence should be greater than ${selectedParent?.questionSequence}`);
            setSeverity("error");
            setOpenAlert(true);
            return
          }
         }
        }
        console.log('formvalues' ,newFormValues)
    setFormValues(newFormValues)
    setStaticFormValue = { ...formValues }
    if (validateForm(newFormValues) == true) {
      saveQuestion(newFormValues, isPublished);
    } else {
      return
    }
  };
const handleChangeCountry = (event) => {
  const { value } = event.target;
  
  // Handle "Select All" case for the main country dropdown
  if (value === "all") {
    const allSelected = selectedCountries.length === submoduleCountries.length;
    if (!allSelected) {
      // Select all countries
      const allCountries = [...submoduleCountries];
      setSelectedCountries(allCountries);
      setSelected(allCountries);
      
      // Also select all countries in other dropdowns
      setMandatoryCountries(allCountries);
      setAuditCountries(allCountries);
      setActiveCountries(allCountries);
      setPromptActionCountries(allCountries);

      // Update form values with all countries
      setFormValues(prev => ({
        ...prev,
        country: { 
          value: allCountries,  // Pass the full array of countries
          error: false,
          errorMessage: "You must select country"
        },
      }));
    } else {
      // Deselect all countries
      setSelectedCountries([]);
      setSelected([]);
      setMandatoryCountries([]);
      setAuditCountries([]);
      setActiveCountries([]);
      setPromptActionCountries([]);

      // Update form values with empty array
      setFormValues(prev => ({
        ...prev,
        country: { 
          value: [],
          error: true,
          errorMessage: "You must select country"
        },
      }));
    }
    return;
  }

  // Handle individual country selection
  const isSelected = selectedCountries.some(
    country => country.countryId === value.countryId
  );

  let newSelectedCountries;
  if (isSelected) {
    // Remove country
    newSelectedCountries = selectedCountries.filter(
      country => country.countryId !== value.countryId
    );
  } else {
    // Add country
    newSelectedCountries = [...selectedCountries, value];
  }

  // Update all dependent country lists
  setSelectedCountries(newSelectedCountries);
  setSelected(newSelectedCountries);
  
  if (isSelected) {
    // Remove from other dropdowns
    setMandatoryCountries(prev => 
      prev.filter(country => country.countryId !== value.countryId)
    );
    setAuditCountries(prev => 
      prev.filter(country => country.countryId !== value.countryId)
    );
    setActiveCountries(prev => 
      prev.filter(country => country.countryId !== value.countryId)
    );
    setPromptActionCountries(prev => 
      prev.filter(country => country.countryId !== value.countryId)
    );
  } else {
    // Add to other dropdowns
    setMandatoryCountries(prev => [...prev, value]);
    setAuditCountries(prev => [...prev, value]);
    setActiveCountries(prev => [...prev, value]);
    setPromptActionCountries(prev => [...prev, value]);
  }
  
  // Update form values with proper validation
  setFormValues(prev => ({
    ...prev,
    country: { 
      value: newSelectedCountries, // Pass the full array of countries
      error: newSelectedCountries.length === 0,
      errorMessage: "You must select country"
    },
  }));
};
  const saveQuestion = (newFormValues, isPublished) => {
    let standardResponseDto = []
    // Format main country IDs
    let allcountryids = selectedCountries.map(country => country.countryId);

    // Format response data
    let resType = getPickListDescription("ERSPTYP", newFormValues?.responseType?.value)
    if (resType == "Dropdown" || resType == "Multi Select Dropdown") {
      modalRows?.map((ele) => {
        let obj = {
        stResponseEN: ele?.name,
        stResponseSequence: ele?.seq,
        stIsActive: true,
        stPriorityResponse: ele?.isPriority || false,
          responseCode:ele?.responseCode,
          stMandatory:ele?.stMandatory
        }
        standardResponseDto.push(obj)
      })
    }
    if (resType == "Radio Button (Yes / No)") {
      standardResponseDto = [{
        stResponseEN: "Yes",
        responseCode:"YES",
        stResponseSequence: 0,
        stIsActive: true
      },
      {
        stResponseEN: "No",
        responseCode:"NO",
        stResponseSequence: "1",
        stIsActive: true
      }]
    }

    // Format parent response
    let parentResponse = "";
    const rawParentValue = newFormValues?.parentReponseValue?.value;
    const responseType = selectedParentOption?.responseType;
    if (responseType === "Multi Select Dropdown" || responseType === "Dropdown" ) {
      parentResponse = rawParentValue
    } else if (responseType === "Radio Button (Yes / No)") {
      const matched = parentResponseOptions.find((opt) => opt.parentResponseText === rawParentValue);
      parentResponse = matched?.parentResponseCode || rawParentValue;
    } else {
      parentResponse = rawParentValue;
    }

    // Format country-specific flags
    const mandatoryFlag = {
      value: newFormValues?.mandatory?.value ? "Y" : "N",
      countryIds: mandatoryCountries.map(country => country.countryId)
    };

    const auditFlagValue = {
      value: newFormValues?.audit?.value ? "Y" : "N",
      countryIds: auditCountries.map(country => country.countryId)
    };

    const activeFlag = {
      value: newFormValues?.active?.value ? "Y" : "N",
      countryIds: activeCountries.map(country => country.countryId)
    };

    const promptActionValue = {
      value: getPickListDescription("EQPACT", newFormValues?.promptAction?.value),
      countryIds: promptActionCountries.map(country => country.countryId)
    };

    const postData = {
      createdByUser: user ? user?.userName : "",
      cropStage: newFormValues?.cropStage?.value,
      cropYearUid: selectedCropYear,
      module: newFormValues?.moduleName?.value,
      subModule: newFormValues?.subModuleName?.value,
      language: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      countryId: allcountryids,
      questionTextEng: newFormValues?.questionText?.value,
      questionType: getPickListDescription("EQSTYP", newFormValues?.questionType?.value),
      responseType: getPickListDescription("ERSPTYP", newFormValues?.responseType?.value),
      questionSequence: newFormValues?.questionSequence?.value ? newFormValues?.questionSequence?.value : questionSequence,
      isQuestionSequenceEdited: newFormValues?.questionSequence?.value ? newFormValues?.questionSequence?.value < setOriginalQuestionSequence ? true : false : false,
      questionInstruction: "",
      multiInstance: newFormValues?.multiInstance?.value,
      parentResponse: parentResponse,
      isMandatory: newFormValues?.mandatory?.value,
      promptActionQue: getPickListDescription("EQPACT", newFormValues?.promptAction?.value),
      promptActionResponseCond: getPickListDescription("ERSPCON", newFormValues?.promptActionReponseCondition?.value),
      promptActionRes: Array.isArray(newFormValues?.promptActionReponseValue?.value)
        ? newFormValues?.promptActionReponseValue?.value.join("|")
        : newFormValues?.promptActionReponseValue?.value,
      isActive: newFormValues?.active?.value,
      isPublished: isPublished,
      auditFlag: newFormValues?.audit?.value,
      questionCode: questionCode || newFormValues?.questionCode?.value,
      parentResponseCond: getPickListDescription("ERSPCON", newFormValues?.parentCondition?.value),
      parentQuestionId: newFormValues?.parentQuestion?.value,
      standardResponseDto: standardResponseDto,
      
      // Add the new formatted flags
      mandatoryFlag,
      auditFlagValue,
      activeFlag,
      promptActionValue
    }
    console.log('postdata' ,postData)
    setLoading(true)
    QuestionnareService.saveQuestion(postData).then((res) => {
      setLoading(false)
      navigate('/QuestionnaireSetup')
      let message = isPublished ? `Published successfully` : `Added successfully`
      setMessage(message);
      setSeverity("success");
      setOpenAlert(true);
    }).catch((ex) => {
      console.log('error', ex)
      setMessage(`Failed to add question`);
      setSeverity("error");
      setOpenAlert(true);
      setLoading(false)
    })
  }
  const getPickListDescription = (listName, pickListId) => {
    // Find the item with the matching pickListId in the specified list
    if (!pickListData) return
    const list = pickListData[listName];
    const item = list.find((entry) => entry.pickListId === pickListId);
    // Return the pickListDescription if found, otherwise return a default message
    return item ? item.pickListDescription : ``;
  };
  const getPickListIdFromDescription = (pData, listName, pickListDescription) => {
    if (!pData) return
    const list = pData[listName];
    const item = list.find((entry) => equalsIgnoreCase(entry.pickListDescription, pickListDescription));
    return item ? item.pickListId : ``;
  };
  const handleParentQuestionChange = (event, newValue) => {
    setFormValues({
      ...formValues,
      parentQuestion: {
        value: newValue?.questionId,
        error: false,
        errorMessage: "You must provide parent question",
      },
      parentReponseValue: {
      value: "", 
      error: false,
      errorMessage: "You must provide parent response",
    },
    })
    setParentResponseOptions(newValue?.parentResponseList || []);
    setSelectedParentOption(newValue);
    setQuestionSequenceDisabled(false)
    setStaticFormValue = { ...formValues }
  };
    
  const hanldeResponseTypeClick = (id, description) => {
    if (formValues?.responseType?.value != id) {
      setModalRows([])
    }
    setSelectedResponseDescription(description);
    if (description == "Dropdown" || description == "Multi Select Dropdown") {
      setOpenModal(true)
    }
    if(description == "Dropdown" || description == "Text Field" ||description == "Integer" ||description == "Date" ||description == "Geo-Location" || description == "Numeric"  ){
       setIsMultiSelect(true)
    } else{
      setIsMultiSelect(false)
    }
  }

  const handleMandatoryCountryChange = (event) => {
    const { value } = event.target;
    setMandatoryCountries(value);
  };

  const handleAuditCountryChange = (event) => {
    const { value } = event.target;
    setAuditCountries(value);
  };

  const handleActiveCountryChange = (event) => {
    const { value } = event.target;
    setActiveCountries(value);
  };

  const handlePromptActionCountryChange = (event) => {
    const { value } = event.target;
    setPromptActionCountries(value);
  };

  const validateCountryDropdowns = () => {
    let errors = false;
    let message = "";

    // Only validate if the corresponding checkbox is checked
    if (formValues?.mandatory?.value && mandatoryCountries.length === 0) {
      errors = true;
      message = "Please select countries for Mandatory";
    }

    if (formValues?.audit?.value && auditCountries.length === 0) {
      errors = true;
      message = message || "Please select countries for Audit";
    }

    if (formValues?.active?.value && activeCountries.length === 0) {
      errors = true;
      message = message || "Please select countries for Active";
    }

    // For prompt action, only validate if value is not "No"
    const promptActionValue = getPickListDescription("EQPACT", formValues?.promptAction?.value);
    if (promptActionValue !== "No" && promptActionCountries.length === 0) {
      errors = true;
      message = message || "Please select countries for Prompt Action";
    }

    return { errors, message };
  };

  return (
    <Layout title="Questionare Setup">
      <div className="Questionnare-setup-container">
        <div
          style={{
            fontWeight: 600,
            fontSize: "1.25rem",
            color: "rgba(115, 125, 134, 1)",
            marginBottom: "1rem",
            paddingLeft: "0.5rem",
          }}
        >
          {location?.state?.mode == "Add" ? "Add Questionnare" : "Edit Questionnare"}
        </div>
        <Box>
          <Card
            variant="outlined"
            sx={{
              height: "50%",
              borderRadius: "10px",
              paddingTop: "10px",
              padding: "2rem",
              boxShadow: "0px 4px 4px 0px #00000040",
            }}
          >
            <Box sx={{ width: '100%' }}>
              <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 0 }}>
                <Grid item xs={12} sm={6} md={4} display="flex" justifyContent="center" alignItems="center">
                  <InputLabel className="Questionnare-setup-label"
                    required
                    sx={{ width: "10rem" }}
                    htmlFor="my-input"
                  >
                    From Crop Year
                  </InputLabel>
                  <TextField
                    select
                    sx={{ width: "300px" }}
                    disabled={readOnly|| mode == "View" || mode == "Edit"}
                    value={selectedCropYear}
                    onChange={(e) => handleChange(e)}
                    name="cropYear"
                    error={formValues.cropYear.error}
                    helperText={
                      formValues.cropYear.error &&
                      formValues.cropYear.errorMessage
                    }
                    required
                    variant="outlined"
                    inputRef={textFieldRef}
                  >
                    <MenuItem key={1} value={"Crop Year"}>
                      Crop Year
                    </MenuItem>
                    {cropYears &&
                      cropYears.map((option) => (
                        <MenuItem
                          key={option.cropYearUid}
                          value={option.cropYearUid}
                        >
                          {option.cyCropYear}
                        </MenuItem>
                      ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6} md={4} display="flex" justifyContent="center" alignItems="center">
                  <InputLabel className="Questionnare-setup-label"
                    required
                    sx={{ width: "10rem" }}
                    htmlFor="my-input"
                  >
                    Crop Stage
                  </InputLabel>
                  <TextField
                    select
                    sx={{ width: "300px" }}
                    disabled={readOnly||mode == "View" || mode == "Edit"}
                    value={formValues.cropStage.value}
                    onChange={(e) => handleChange(e)}
                    name="cropStage"
                    error={formValues.cropStage.error}
                    helperText={
                      formValues.cropStage.error &&
                      formValues.cropStage.errorMessage
                    }
                    required
                    variant="outlined"
                  >
                    {cropStages &&
                      cropStages.map((option) => (
                        <MenuItem
                          key={option.cropStageUid}
                          value={option.cropStageUid}
                        >
                          {option.cropStageName}
                        </MenuItem>
                      ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6} md={4} display="flex" justifyContent="center" alignItems="center">
                  <InputLabel className="Questionnare-setup-label"
                    required
                    sx={{ width: "10rem" }}
                    htmlFor="my-input"
                  >
                    Module Name
                  </InputLabel>
                  <TextField
                    select
                    sx={{ width: "300px" }}
                    disabled={readOnly||mode == "View" || mode == "Edit"}
                    value={formValues.moduleName.value}
                    onChange={(e) => handleChange(e)}
                    name="moduleName"
                    error={formValues.moduleName.error}
                    helperText={
                      formValues.moduleName.error &&
                      formValues.moduleName.errorMessage
                    }
                    required
                    variant="outlined"
                  >
                    {modules &&
                      modules.map((option) => (
                        <MenuItem
                          key={option.moduleId}
                          value={option.moduleId}
                        >
                          {option.moduleName}
                        </MenuItem>
                      ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6} md={4} display="flex" justifyContent="center" alignItems="center">
                  <InputLabel className="Questionnare-setup-label"
                    required
                    sx={{ width: "10rem" }}
                    htmlFor="my-input"
                  >
                    Sub Module Name
                  </InputLabel>
                  <TextField
                    select
                    multiple
                    sx={{ width: "300px" }}
                    disabled={readOnly||mode == "View" || mode == "Edit"}
                    value={formValues.subModuleName.value}
                    onChange={(e) => handleChange(e)}
                    name="subModuleName"
                    error={formValues.subModuleName.error}
                    helperText={
                      formValues.subModuleName.error &&
                      formValues.subModuleName.errorMessage
                    }
                    required
                    variant="outlined"
                  >
                    {subModules &&
                      subModules.map((option) => (
                        <MenuItem
                          key={option.subModuleId}
                          value={option.subModuleId}
                        >
                          {option.subModuleName}
                        </MenuItem>
                      ))}
                  </TextField>

                </Grid>
                <Grid item xs={12} sm={6} md={4} display="flex" justifyContent="center" alignItems="center">
                  <InputLabel className="Questionnare-setup-label"
                    required
                    sx={{ width: "10rem" }}
                    htmlFor="my-input"
                  >
                    Country
                  </InputLabel>
                  <Box>
                    <Select
                      sx={{ width: textFieldWidth }}
                      disabled={readOnly||mode == "View"}
                      multiple
                      name="country"
                      value={selectedCountries}
                      onChange={(e) => handleChangeCountry(e)}
                      renderValue={(selected) =>
                        selected.map((select) => select.countryName).join(", ")
                      }
                      error={formValues.country.error}
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 250,
                            overflowY: "auto",
                          },
                        },
                      }}
                    >
                      <MenuItem value="all">
                        <ListItemIcon>
                          <Checkbox
                            checked={selectedCountries.length === submoduleCountries.length}
                            icon={<img src={CheckboxUntick} />}
                            checkedIcon={<img src={CheckboxTick} />}
                            onChange={(e) => {
                              if (e.target.checked) {
                                const allCountries = [...submoduleCountries];
                                setSelectedCountries(allCountries);
                                setSelected(allCountries);
                                // Also select all countries in other dropdowns
                                setMandatoryCountries(allCountries);
                                setAuditCountries(allCountries);
                                setActiveCountries(allCountries);
                                setPromptActionCountries(allCountries);
                              } else {
                                // Clear all selections
                                setSelectedCountries([]);
                                setSelected([]);
                                setMandatoryCountries([]);
                                setAuditCountries([]);
                                setActiveCountries([]);
                                setPromptActionCountries([]);
                              }
                            }}
                          />
                        </ListItemIcon>
                        <ListItemText primary="Select All" />
                      </MenuItem>
                      {submoduleCountries.map((country) => (
                        <MenuItem 
                          key={country.countryId} 
                          value={country}
                        >
                          <ListItemIcon>
                            <Checkbox
                              checked={selectedCountries.some(
                                selected => selected.countryId === country.countryId
                              )}
                              icon={<img src={CheckboxUntick} />}
                              checkedIcon={<img src={CheckboxTick} />}
                              onChange={(e) => {
                                handleChangeCountry({ target: { value: country } });
                              }}
                            />
                          </ListItemIcon>
                          <ListItemText primary={country.countryName} />
                        </MenuItem>
                      ))}
                    </Select>
                    {formValues.country.error && <p className="questionnare-custom-error">{formValues.country.errorMessage}</p>}
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Card>
          <Card
            variant="outlined"
            sx={{
              height: "50%",
              borderRadius: "10px",
              paddingTop: "10px",
              padding: "2rem",
              marginTop: "20px",
              boxShadow: "0px 4px 4px 0px #00000040",
            }}
          >
            <Box sx={{ width: '100%' }}>
              <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 0 }}>
                <Grid item xs={12} sm={6} md={4} display="flex" justifyContent="center" alignItems="center">
                  <InputLabel className="Questionnare-setup-label"
                    sx={{ width: "10rem" }}
                    htmlFor="my-input"
                  >
                    Question Code
                  </InputLabel>
                  <TextField
                    sx={{ width: "300px" }}

                    value={questionCode ? questionCode : formValues.questionCode.value}
                    onChange={(e) => handleChange(e)}
                    name="questionCode"
                    disabled
                    variant="outlined"
                  >
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6} md={4} display="flex" justifyContent="center" alignItems="center">
                  <InputLabel className="Questionnare-setup-label"
                    required
                    sx={{ width: "10rem" }}
                    htmlFor="my-input"
                  >
                    Question Type
                  </InputLabel>
                  <TextField
                    select
                    sx={{ width: "300px" }}
                    disabled={readOnly||mode == "View"}
                    value={formValues.questionType.value}
                    onChange={(e) => handleChange(e)}
                    name="questionType"
                    error={formValues.questionType.error}
                    helperText={
                      formValues.questionType.error &&
                      formValues.questionType.errorMessage
                    }
                    required
                    variant="outlined"
                  >
                    <MenuItem key={1} value={"Question Type"}>
                      Question Type
                    </MenuItem>
                    {pickListData &&
                      pickListData?.EQSTYP?.map((option) => (
                        <MenuItem
                          key={option.pickListId}
                          value={option.pickListId}
                        >
                          {option.pickListDescription}
                        </MenuItem>
                      ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6} md={4} display="flex" justifyContent="center" alignItems="center">
                  <InputLabel className="Questionnare-setup-label"
                    required
                    sx={{ width: "10rem" }}
                    htmlFor="my-input"
                  >
                    Question Sequence
                  </InputLabel>
                  <TextField
                    sx={{ width: "300px" }}
                    disabled={readOnly||mode == "View" || questionSequenceDisabled}
                    // value={formValues.questionSequence.value || questionSequence}
                    value={questionSequence}
                    onChange={(e) => handleChange(e)}
                    name="questionSequence"
                    error={formValues.questionSequence.error}
                    helperText={
                      formValues.questionSequence.error &&
                      formValues.questionSequence.errorMessage
                    }
                    required
                    variant="outlined"
                  >
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6} md={4} display="flex" justifyContent="center" alignItems="center">
                  <InputLabel className="Questionnare-setup-label"
                    required
                    sx={{ width: "10rem" }}
                    htmlFor="my-input"
                  >
                    Response Type
                  </InputLabel>
                  <TextField
                    select
                    sx={{ width: "300px" }}
                    disabled={readOnly||mode == "View"}
                    value={formValues.responseType.value}
                    onChange={(e) => handleChange(e)}
                    name="responseType"
                    error={formValues.responseType.error}
                    helperText={
                      formValues.responseType.error &&
                      formValues.responseType.errorMessage
                    }
                    required
                    variant="outlined"
                  >
                    <MenuItem key={1} value={"Answer Type"}>
                      Answer Type
                    </MenuItem>
                    {pickListData &&
                      pickListData?.ERSPTYP?.map((option) => (
                        <MenuItem
                          key={option.pickListId}
                          value={option.pickListId}
                          onClick={() => { hanldeResponseTypeClick(option.pickListId, option?.pickListDescription) }}

                        >
                          {option.pickListDescription}
                        </MenuItem>
                      ))}
                  </TextField>
                </Grid>
              </Grid>
            </Box>
          </Card>
          <Card
            variant="outlined"
            sx={{
              height: "50%",
              borderRadius: "10px",
              paddingTop: "10px",
              padding: "2rem",
              marginTop: "20px",
              boxShadow: "0px 4px 4px 0px #00000040",
            }}
          >

            <Box sx={{ width: '100%' }}>
              <Grid container
                rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 0 }}
                display="flex"
                justifyContent="space-between"
              >
                {/* Mandatory Section */}
                <Box sx={{ display: "flex", flexDirection: "column", padding: "8px" }}>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <InputLabel sx={{ width: "10rem" }}>Mandatory</InputLabel>
                    <Checkbox
                      disabled={readOnly || mode == "View"}
                      name="mandatory"
                      checked={formValues?.mandatory?.value == true}
                      onChange={(e) => handleChange(e)}
                    />
                  </Box>
                  <Box sx={{ mt: 1 }}>
                    <Select
                      multiple
                      value={mandatoryCountries}
                      onChange={handleMandatoryCountryChange}
                      disabled={readOnly||!formValues?.mandatory?.value}
                      renderValue={(selected) => 
                        selected.map(country => country.countryName).join(", ")
                      }
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 250,
                            overflowY: "auto",
                          },
                        },
                      }}
                      sx={{ 
                        width: "300px", // Fixed width
                        '& .MuiSelect-select': {
                          maxWidth: "300px", // Keep text within bounds
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap"
                        }
                      }}
                      error={formValues?.mandatory?.value && mandatoryCountries.length === 0}
                      required={formValues?.mandatory?.value}
                    >
                      <MenuItem value="all">
                        <ListItemIcon>
                          <Checkbox
                            checked={mandatoryCountries.length === selectedCountries.length}
                            icon={<img src={CheckboxUntick} />}
                            checkedIcon={<img src={CheckboxTick} />}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setMandatoryCountries([...selectedCountries]);
                              } else {
                                setMandatoryCountries([]);
                              }
                            }}
                          />
                        </ListItemIcon>
                        <ListItemText primary="Select All" />
                      </MenuItem>
                      {selectedCountries.map((country) => (
                        <MenuItem key={country.countryId} value={country}>
                          <ListItemIcon>
                            <Checkbox
                              checked={mandatoryCountries.some(
                                (selected) => selected.countryId === country.countryId
                              )}
                              icon={<img src={CheckboxUntick} />}
                              checkedIcon={<img src={CheckboxTick} />}
                            />
                          </ListItemIcon>
                          <ListItemText primary={country.countryName} />
                        </MenuItem>
                      ))}
                    </Select>
                  </Box>
                </Box>

                {/* Audit Section */}
                <Box sx={{ display: "flex", flexDirection: "column", padding: "8px" }}>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <InputLabel sx={{ width: "10rem" }}>Audit</InputLabel>
                    <Checkbox
                      disabled={readOnly||mode == "View"}
                      name="audit"
                      checked={formValues?.audit?.value == true}
                      onChange={(e) => handleChange(e)}
                    />
                  </Box>
                  <Box sx={{ mt: 1 }}>
                    <Select
                      multiple
                      value={auditCountries}
                      onChange={handleAuditCountryChange}
                      disabled={readOnly||!formValues?.audit?.value}
                      renderValue={(selected) => 
                        selected.map(country => country.countryName).join(", ")
                      }
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 250,
                            overflowY: "auto",
                          },
                        },
                      }}
                      sx={{ 
                        width: "300px", // Fixed width
                        '& .MuiSelect-select': {
                          maxWidth: "300px", // Keep text within bounds
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap"
                        }
                      }}
                      error={formValues?.audit?.value && auditCountries.length === 0}
                      required={formValues?.audit?.value}
                    >
                      <MenuItem value="all">
                        <ListItemIcon>
                          <Checkbox
                            checked={auditCountries.length === selectedCountries.length}
                            icon={<img src={CheckboxUntick} />}
                            checkedIcon={<img src={CheckboxTick} />}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setAuditCountries([...selectedCountries]);
                              } else {
                                setAuditCountries([]);
                              }
                            }}
                          />
                        </ListItemIcon>
                        <ListItemText primary="Select All" />
                      </MenuItem>
                      {selectedCountries.map((country) => (
                        <MenuItem key={country.countryId} value={country}>
                          <ListItemIcon>
                            <Checkbox
                              checked={auditCountries.some(
                                (selected) => selected.countryId === country.countryId
                              )}
                              icon={<img src={CheckboxUntick} />}
                              checkedIcon={<img src={CheckboxTick} />}
                            />
                          </ListItemIcon>
                          <ListItemText primary={country.countryName} />
                        </MenuItem>
                      ))}
                    </Select>
                  </Box>
                </Box>

                {/* Active Section */}
                <Box sx={{ display: "flex", flexDirection: "column", padding: "8px" }}>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <InputLabel sx={{ width: "10rem" }}>Active</InputLabel>
                    <Checkbox
                      disabled={readOnly||mode == "View"}
                      name="active"
                      checked={formValues?.active?.value == true}
                      onChange={(e) => handleChange(e)}
                    />
                  </Box>
                  <Box sx={{ mt: 1 }}>
                    <Select
                      multiple
                      value={activeCountries}
                      onChange={handleActiveCountryChange}
                      disabled={readOnly||!formValues?.active?.value}
                      renderValue={(selected) => 
                        selected.map(country => country.countryName).join(", ")
                      }
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 250,
                            overflowY: "auto",
                          },
                        },
                      }}
                      sx={{ 
                        width: "300px", // Fixed width
                        '& .MuiSelect-select': {
                          maxWidth: "300px", // Keep text within bounds
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap"
                        }
                      }}
                      error={formValues?.active?.value && activeCountries.length === 0}
                      required={formValues?.active?.value}
                    >
                      <MenuItem value="all">
                        <ListItemIcon>
                          <Checkbox
                            checked={activeCountries.length === selectedCountries.length}
                            icon={<img src={CheckboxUntick} />}
                            checkedIcon={<img src={CheckboxTick} />}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setActiveCountries([...selectedCountries]);
                              } else {
                                setActiveCountries([]);
                              }
                            }}
                          />
                        </ListItemIcon>
                        <ListItemText primary="Select All" />
                      </MenuItem>
                      {selectedCountries.map((country) => (
                        <MenuItem key={country.countryId} value={country}>
                          <ListItemIcon>
                            <Checkbox
                              checked={activeCountries.some(
                                (selected) => selected.countryId === country.countryId
                              )}
                              icon={<img src={CheckboxUntick} />}
                              checkedIcon={<img src={CheckboxTick} />}
                            />
                          </ListItemIcon>
                          <ListItemText primary={country.countryName} />
                        </MenuItem>
                      ))}
                    </Select>
                  </Box>
                </Box>

                {isMultiSelect &&
                  <Box sx={{ display: "flex", alignItems: "flex-start", padding: "8px" }}>
                    <InputLabel className="Questionnare-setup-label"
                      sx={{ width: "10rem" }}
                      htmlFor="my-input"
                    >
                      Multi Instance
                    </InputLabel>
                    <Checkbox
                      disabled={readOnly||mode == "View"}
                      name="multiInstance"
                      checked={formValues?.multiInstance?.value == true}
                      onChange={(e) => handleChange(e)}
                      sx={{  marginTop:"-4px"}}
                    />
                  </Box>
                }
              </Grid>
            </Box>
          </Card>
          <Card
            variant="outlined"
            sx={{
              height: "50%",
              borderRadius: "10px",
              paddingTop: "10px",
              padding: "2rem",
              marginTop: "20px",
              boxShadow: "0px 4px 4px 0px #00000040",
            }}
          >
            <Box sx={{ width: '100%' }}>
              <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 0 }}>
                <Grid item xs={12} sm={6} md={4} display="flex" justifyContent="center" alignItems="center">
                  <InputLabel className="Questionnare-setup-label"
                    required={promptMandatory}
                    sx={{ width: "10rem" }}
                    htmlFor="my-input"
                  >
                    Prompt Action
                  </InputLabel>
                  <TextField
                    select
                    sx={{ width: "300px" }}
                    disabled={readOnly||!promptMandatory || mode == "View"}
                    value={formValues.promptAction.value}
                    onChange={(e) => handleChange(e)}
                    name="promptAction"
                    error={formValues.promptAction.error}
                    helperText={
                      formValues.promptAction.error &&
                      formValues.promptAction.errorMessage
                    }
                    required
                    variant="outlined"
                  >
                    {/* <MenuItem key={1} value={"Prompt Action"}>
                      Prompt Action
                    </MenuItem> */}
                    {pickListData &&
                      pickListData?.EQPACT?.map((option) => (
                        <MenuItem
                          key={option.pickListId}
                          value={option.pickListId}
                        >
                          {option.pickListDescription}
                        </MenuItem>
                      ))}
                  </TextField>
                  
                </Grid>
                <Grid item xs={12} sm={6} md={4} display="flex" justifyContent="center" alignItems="center">
                <InputLabel className="Questionnare-setup-label"
                    required
                    sx={{ width: "10rem" }}
                    htmlFor="my-input"
                  >
                    Countries Prompt Action
                  </InputLabel>
                <Box sx={{ mt: 1 }}>
                    <Select
                      multiple
                      value={promptActionCountries}
                      onChange={handlePromptActionCountryChange}
                      disabled={readOnly||equalsIgnoreCase(getPickListDescription("EQPACT", formValues?.promptAction?.value), "No")}
                      renderValue={(selected) => 
                        selected.map(country => country.countryName).join(", ")
                      }
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 250,
                            overflowY: "auto",
                          },
                        },
                      }}
                      sx={{ 
                        width: "300px",
                        '& .MuiSelect-select': {
                          maxWidth: "300px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap"
                        }
                      }}
                      error={
                        !equalsIgnoreCase(getPickListDescription("EQPACT", formValues?.promptAction?.value), "No") &&
                        promptActionCountries.length === 0
                      }
                      required={!equalsIgnoreCase(getPickListDescription("EQPACT", formValues?.promptAction?.value), "No")}
                    >
                      <MenuItem value="all">
                        <ListItemIcon>
                          <Checkbox
                            checked={promptActionCountries.length === selectedCountries.length}
                            icon={<img src={CheckboxUntick} />}
                            checkedIcon={<img src={CheckboxTick} />}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setPromptActionCountries([...selectedCountries]);
                              } else {
                                setPromptActionCountries([]);
                              }
                            }}
                          />
                        </ListItemIcon>
                        <ListItemText primary="Select All" />
                      </MenuItem>
                      {selectedCountries.map((country) => (
                        <MenuItem key={country.countryId} value={country}>
                          <ListItemIcon>
                            <Checkbox
                              checked={promptActionCountries.some(
                                (selected) => selected.countryId === country.countryId
                              )}
                              icon={<img src={CheckboxUntick} />}
                              checkedIcon={<img src={CheckboxTick} />}
                            />
                          </ListItemIcon>
                          <ListItemText primary={country.countryName} />
                        </MenuItem>
                      ))}
                    </Select>
                  </Box>
                  </Grid>
                <Grid item xs={12} sm={6} md={4} display="flex" justifyContent="center" alignItems="center">
                  <InputLabel className="Questionnare-setup-label"
                    required={promptMandatory}
                    sx={{ width: "10rem" }}
                    htmlFor="my-input"
                  >
                    Prompt Action Response Condition
                  </InputLabel>
                  <TextField
                    select
                    sx={{ width: "300px" }}
                    disabled={readOnly||mode == "View"}
                    value={formValues.promptActionReponseCondition.value}
                    onChange={(e) => handleChange(e)}
                    name="promptActionReponseCondition"
                    error={formValues.promptActionReponseCondition.error}
                    helperText={
                      formValues.promptActionReponseCondition.error &&
                      formValues.promptActionReponseCondition.errorMessage
                    }
                    required
                    variant="outlined"
                  >
                    <MenuItem key={1} value={"Select Condition"}>
                      Select Condition
                    </MenuItem>
                    {pickListData &&
                      pickListData?.ERSPCON?.map((option) => (
                        <MenuItem
                          key={option.pickListId}
                          value={option.pickListId}
                        >
                          {option.pickListDescription}
                        </MenuItem>
                      ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6} md={4} display="flex" justifyContent="center" alignItems="center">
                  <InputLabel className="Questionnare-setup-label"
                    required={promptMandatory}
                    sx={{ width: "10rem" }}
                    htmlFor="my-input"
                  >
                    Prompt Action Response Values
                  </InputLabel>
     {(selectedResponseDescription === "Dropdown" || selectedResponseDescription === "Multi Select Dropdown") ? (
        <Autocomplete
          multiple
          disableCloseOnSelect
          disabled={readOnly || mode === "View" || mode==="newView"}
          options={modalRows || []}
          getOptionLabel={(option) => option.name}
          value={modalRows?.filter(row => 
            formValues?.promptActionReponseValue?.value
              ?.split('|')
              ?.includes(row.responseCode)
          ) || []}
          onChange={(event, newValues) => {
            const selectedIds = newValues.map(v => v.responseCode);
            const syntheticEvent = {
              target: {
                name: 'promptActionReponseValue',
                value: selectedIds.join('|')
              }
            };
            handleChange(syntheticEvent);
          }}
          renderTags={(selected, getTagProps) => (
            <span >
              {selected.map(s => s.name).join('\u200B|')}
            </span>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              sx={{ 
                width: "300px",
                '& .MuiOutlinedInput-root': {
                  '& input': { padding: '8px 14px' },
                  '& .MuiAutocomplete-input': { padding: '8px 14px !important' },
                  '& .MuiAutocomplete-endAdornment': { right: '8px' }
                },
                '& .MuiOutlinedInput-input': { padding: '8px 14px' },
                '& .MuiAutocomplete-tag': {
                  margin: '3px',
                  padding: '0 8px'
                }
              }}
              variant="outlined"
              error={formValues?.promptActionReponseValue.error}
              helperText={
                formValues?.promptActionReponseValue.error &&
                formValues?.promptActionReponseValue.errorMessage
              }
              placeholder={!formValues?.promptActionReponseValue?.value ? "Select Response" : ""}
            />
          )}
          renderOption={(props, option, { selected }) => (
            <MenuItem {...props}>
              <ListItemText primary={option.name} />
            </MenuItem>
          )}
        />
      ) 
   : selectedResponseDescription === "Radio Button (Yes / No)" ? (
    <TextField
      select
      sx={{ width: "300px" }}
      disabled={readOnly||mode === "View"}
      value={formValues.promptActionReponseValue.value}
      onChange={(e) => handleChange(e)}
      name="promptActionReponseValue"
      error={formValues.promptActionReponseValue.error}
      helperText={
        formValues.promptActionReponseValue.error &&
        formValues.promptActionReponseValue.errorMessage
      }
      required
      variant="outlined"
    >
      <MenuItem value="" disabled>Select Value</MenuItem>
      <MenuItem value="YES">Yes</MenuItem>
      <MenuItem value="NO">No</MenuItem>
    </TextField>
  ) : (
    <TextField
      sx={{ width: "300px" }}
      disabled={readOnly||mode === "View"}
      value={formValues.promptActionReponseValue.value}
      onChange={(e) => handleChange(e)}
      name="promptActionReponseValue"
      error={formValues.promptActionReponseValue.error}
      helperText={
        formValues.promptActionReponseValue.error &&
        formValues.promptActionReponseValue.errorMessage
      }
      required
      variant="outlined"
    />
  )}                
    </Grid>

                <Grid item xs={12} sm={6} md={4} display="flex" justifyContent="center" alignItems="center">
                  <InputLabel className="Questionnare-setup-label"
                    required={parentMandatory}
                    sx={{ width: "10rem" }}
                    htmlFor="my-input"
                  >
                    Parent Question
                  </InputLabel>
                  <Autocomplete
                    sx={{ width: "300px", '& .MuiInputBase-root': { paddingRight: "20% !important" } }}
                    disabled={readOnly||mode == "View" || parentMandatory == false}
                    options={options}
                    getOptionLabel={(option) => option.questionCode} // Adjust based on your data
                    loading={loading}
                    value={selectedParentOption}
                    onInputChange={(event, newInputValue) => {
                      setInputValue(event?.target?.value);
                    }}

                    onChange={(event, newValue) => {
                      setSelectedParentOption(newValue);
                      handleParentQuestionChange(event, newValue)
                    }}
                    renderInput={(params) => (
                      <TextField
                        name="parentQuestion"
                        width="100%"
                        {...params}
                        label="Search"
                        variant="outlined"
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <InputAdornment position="end" sx={{ marginRight: "-10%" }}>
                              {loading ? <CircularProgress color="inherit" size={20} /> : <SearchIcon />}
                            </InputAdornment>
                          ),
                        }}
                        error={formValues.parentQuestion.error}
                        helperText={
                          formValues.parentQuestion.error &&
                          formValues.parentQuestion.errorMessage
                        }
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} display="flex" justifyContent="center" alignItems="center">
                  <InputLabel className="Questionnare-setup-label"
                    required={parentMandatory}
                    sx={{ width: "10rem" }}
                    htmlFor="my-input"
                  >
                    Parent Condition
                  </InputLabel>
                  <TextField
                    select
                    sx={{ width: "300px" }}
                    disabled={readOnly||mode == "View" || parentMandatory == false}
                    value={formValues.parentCondition.value}
                    onChange={(e) => handleChange(e)}
                    name="parentCondition"
                    error={formValues.parentCondition.error}
                    helperText={
                      formValues.parentCondition.error &&
                      formValues.parentCondition.errorMessage
                    }
                    required={parentMandatory}

                    variant="outlined"
                  >
                    <MenuItem key={1} value={"Select Parent Condition"}>
                      Select Parent Condition
                    </MenuItem>
                    {pickListData &&
                      pickListData?.ERSPCON?.map((option) => (
                        <MenuItem
                          key={option.pickListId}
                          value={option.pickListId}
                        >
                          {option.pickListDescription}
                        </MenuItem>
                      ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6} md={4} display="flex" justifyContent="center" alignItems="center">
                  <InputLabel className="Questionnare-setup-label"
                    required={parentMandatory}
                    sx={{ width: "10rem" }}
                    htmlFor="my-input"
                  >
                    Parent Response Value
                  </InputLabel>
                    {/*  Multi Select Dropdown */}
  {(selectedParentOption?.responseType === "Dropdown" || selectedParentOption?.responseType === "Multi Select Dropdown") && (
    <Autocomplete
      multiple
      disableCloseOnSelect
      options={parentResponseOptions}
      getOptionLabel={(option) => option.parentResponseText}
      value={parentResponseOptions.filter(opt =>
        formValues.parentReponseValue.value
          ?.split('|')
          .includes(opt.parentResponseCode)
      )}
      onChange={(event, newValues) => {
        const selectedTexts = newValues.map(v => v.parentResponseCode);
        setFormValues({
          ...formValues,
          parentReponseValue: {
            value: selectedTexts.join('|'),
            error: parentMandatory && selectedTexts.length === 0,
            errorMessage: "You must provide parent response",
          },
        });
      }}
      renderTags={(selected) => (
        <span>
          {selected.map(s => s.parentResponseText).join('\u200B|')}
        </span>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          sx={{ width: "300px" }}
          variant="outlined"
          disabled={readOnly}
          error={formValues.parentReponseValue.error}
          helperText={
            formValues.parentReponseValue.error &&
            formValues.parentReponseValue.errorMessage
          }
        />
      )}
    />
  )}

  {/*  Single Select Dropdown */}
  {(
    // selectedParentOption?.responseType === "Dropdown" ||
    selectedParentOption?.responseType === "Radio Button (Yes / No)") && (
    <TextField
      select
      sx={{ width: "300px" }}
      disabled={ readOnly||mode === "View" || parentMandatory === false}
      value={formValues.parentReponseValue.value}
      onChange={(e) =>
        setFormValues({
          ...formValues,
          parentReponseValue: {
            value: e.target.value,
            error: parentMandatory && e.target.value === "",
            errorMessage: "You must provide parent response",
          },
        })
      }
      error={formValues.parentReponseValue.error}
      helperText={
        formValues.parentReponseValue.error &&
        formValues.parentReponseValue.errorMessage
      }
      variant="outlined"
    >
      {parentResponseOptions.map((option, index) => (
        <MenuItem key={index} value={option.parentResponseText}>
          {option.parentResponseText}
        </MenuItem>
      ))}
    </TextField>
  )}

  {/*   Text Input */}
  {!["Dropdown", "Multi Select Dropdown", "Radio Button (Yes / No)"].includes(
    selectedParentOption?.responseType
  ) && (
    <TextField
      sx={{ width: "300px" }}
      disabled={readOnly||mode === "View" || parentMandatory === false}
      value={formValues.parentReponseValue.value}
      onChange={(e) =>
        setFormValues({
          ...formValues,
          parentReponseValue: {
            value: e.target.value,
            error: parentMandatory && e.target.value === "",
            errorMessage: "You must provide parent response",
          },
        })
      }
      error={formValues.parentReponseValue.error}
      helperText={
        formValues.parentReponseValue.error &&
        formValues.parentReponseValue.errorMessage
      }
      variant="outlined"
    />
  )}
                </Grid>
                <Grid item xs={12} sm={12} md={12} display="flex" alignItems="center">
                  <InputLabel className="Questionnare-setup-label"
                    required
                    sx={{ width: "10rem", justifyContent: "right", display: 'flex' }}
                    htmlFor="my-input"
                  >
                    Question Text
                  </InputLabel>
                  <TextField
                    disabled={readOnly||mode == "View"}
                    onChange={(e) => handleChange(e)}
                    name="questionText"
                    value={formValues.questionText.value}
                    className="Questionare-setup-textarea"
                    placeholder="Type here.."
                    multiline
                    rows={4}
                    variant="outlined"
                    error={formValues.questionText.error}
                    helperText={
                      formValues.questionText.error &&
                      formValues.questionText.errorMessage
                    }
                  />
                </Grid>
              </Grid>
              <Grid
                container
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "20px",
                  paddingTop: "40px",
                }}
              >

                {readOnly||mode == "View" ? <Button
                  disabled={loading}
                  style={{ backgroundColor: "#112A63", minWidth: "92px" }}
                  variant="contained"
                  type="button"
                  onClick={(e) => navigate('/QuestionnaireSetup')}
                >
                  {loading && <CircularProgress size={20} />}
                  BACK
                </Button> :
                  <>
                    <Button
                      disabled={loading}
                      style={{ backgroundColor: "#737D86", minWidth: "92px" }}
                      variant="contained"
                      onClick={() => navigate('/QuestionnaireSetup')}
                    >
                      {" "}
                      {"CANCEL"}

                    </Button>
                    <Button
                      disabled={loading}
                      style={{ backgroundColor: "#112A63", minWidth: "92px" }}
                      variant="contained"
                      type="button"
                      onClick={(e) => handleSubmit(e, false)}
                    >
                      {loading && <CircularProgress size={20} />}
                      {location?.state?.mode == "Edit" ? "UPDATE" : "SAVE"}
                    </Button>
                    <Button
                      disabled={loading}
                      style={{ backgroundColor: "#EF7D00", minWidth: "92px" }}
                      variant="contained"
                      type="button"
                      onClick={(e) => handleSubmit(e, true)}
                    >
                      {loading && <CircularProgress size={20} />}
                      {"PUBLISH"}
                    </Button>
                  </>
                }
              </Grid>
            </Box>
          </Card>
        </Box>
      </div>
      <DropdownModal loading={loading}
      isGlobalUser={isGlobalUser}
        modalRows={modalRows}
        questionCode={questionCode}
        setModalRows={(rows) => { setModalRows(rows) }}
        open={openModal} onClose={() => { setOpenModal(false) }} 
        desc={selectedResponseDescription}/>
    </Layout >
  );
};
export default QuestionnareAdd;
